module.exports = __webpack_public_path__ + "img/traitement2.b603a490.jpg";